module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-grid-f720ad399a9fd19270e1cff08a3bc0af.svg";